let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("avby0")).then(() => parcelRequire('eCjgs'));